import { useState } from 'react';
import { useNotificationsSnackbar } from '@/components/snackbar/NotificationsSnackbarContext';
import { AddCompanyDialog } from './AddCompanyDialog';
import { CreateCompanyRequest } from '@/models/company';
import { Validator, useErrorHandling } from '@/utils/errorHandling';
import { PrimaryButton } from '@/components/shared/Button';
import { useUsersMutations } from '@/services/usersMutations';

export type AddCompanyFormProps = {
    onAddSuccess: () => void;
};

export const AddCompanyForm = (props: AddCompanyFormProps) => {
    const { setAlert } = useNotificationsSnackbar();
    const { backendErrorHandler } = useErrorHandling();
    const { createCompany } = useUsersMutations();
    const [open, setOpen] = useState(false);
    const [validator, setValidator] = useState(new Validator());

    const onClickOpen = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onAdd = async (
        request: CreateCompanyRequest,
        onSuccess: () => void
    ): Promise<void> => {
        createCompany.mutate(request, {
            onSuccess: () => {
                setAlert('New company added successfully.', 'success');
                setOpen(false);
                setValidator(validator.clearErrors());
                onSuccess();
                props.onAddSuccess();
            },
            onError: (e: any) => {
                backendErrorHandler(undefined, (_e, errorDetails) => {
                    setValidator(new Validator(errorDetails?.errors));
                })(e);
            }
        });
    };

    return (
        <>
            {/* <Typography variant="h5">Manage companies</Typography>
            <Box>Here you can add new companies and initial admin users.</Box> */}
            <PrimaryButton
                size="small"
                variant="contained"
                onClick={onClickOpen}
            >
                Add company
            </PrimaryButton>
            <AddCompanyDialog
                validator={validator}
                setValidator={setValidator}
                open={open}
                onClose={onClose}
                onAdd={onAdd}
                isLoading={createCompany.isPending}
            />
        </>
    );
};
